import { alpha, createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#F5A623",
    },
    secondary: {
      main: "#2F4E8B",
    },
    background: {
      default: "#EEF3FB",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#102B63",
      secondary: "#465C84",
    },
  },
  shape: {
    borderRadius: 20,
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Arial", sans-serif',
    h1: {
      fontWeight: 950,
      lineHeight: 0.94,
      letterSpacing: "-0.065em",
    },
    h2: {
      fontWeight: 900,
      lineHeight: 0.98,
      letterSpacing: "-0.05em",
    },
    h3: {
      fontWeight: 850,
      lineHeight: 1.04,
      letterSpacing: "-0.03em",
    },
    h4: {
      fontWeight: 820,
      lineHeight: 1.08,
      letterSpacing: "-0.02em",
    },
    h5: {
      fontWeight: 800,
      lineHeight: 1.14,
    },
    body1: {
      lineHeight: 1.82,
      fontSize: "1rem",
    },
    body2: {
      lineHeight: 1.72,
      fontSize: "0.96rem",
    },
    button: {
      textTransform: "none",
      fontWeight: 850,
      letterSpacing: "0.01em",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
          textRendering: "optimizeLegibility",
          scrollBehavior: "smooth",
        },
        body: {
          background: `
            radial-gradient(circle at 12% 10%, rgba(47,78,139,0.06), transparent 18%),
            radial-gradient(circle at 90% 8%, rgba(245,166,35,0.08), transparent 14%),
            linear-gradient(180deg, #F4F7FC 0%, #EDF2FB 100%)
          `,
        },
        a: {
          color: "inherit",
          textDecoration: "none",
        },
        "::selection": {
          background: "#F5A623",
          color: "#102B63",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: `1px solid ${alpha("#102B63", 0.08)}`,
          boxShadow: "0 16px 40px rgba(16,43,99,0.08)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: `1px solid ${alpha("#102B63", 0.08)}`,
          boxShadow: "0 16px 40px rgba(16,43,99,0.08)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          minHeight: 52,
          paddingInline: 24,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 800,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          "@media (min-width: 1536px)": {
            maxWidth: "1180px",
          },
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;